/* eslint-disable */
<template>
  <div>
    <vx-card title="Adicionar Empresa" class="mb-4">

      <!--Nome-->
      <vs-row class="mb-2">
        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <label>Nome</label>
          <vs-input
            v-model="company.name"
            v-validate="'required'"
            name="nome"
            class="w-full d-inline"/>
        </vs-col>

        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <label>CNPJ</label>
          <CnpjInput
            v-model="company.cnpjAlfa"
            v-validate="'required'"
            name="cnpj"
            class="w-full d-inline"/>
        </vs-col>
      </vs-row>

      <!--Setor e CNPJ-->
      <vs-row>
        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <label>Setor</label>
          <vs-select
            v-model="company.sector"
            v-validate="'required'"
            autocomplete
            name="setor"
            class="w-full d-inline">
            <vs-select-item :key="index" :value="item" :text="item.name" v-for="(item, index) in sectors"/>
          </vs-select>
        </vs-col>

        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <label>Tipo Agente</label>
          <vs-select
            v-model="company.companyType"
            v-validate="'required'"
            autocomplete
            name="tipo agente"
            class="w-full d-inline">
            <vs-select-item :key="index" :value="item.type" :text="item.description" v-for="(item, index) in companyTypes"/>
          </vs-select>
        </vs-col>
      </vs-row>

      <!--Endereço-->
      <vs-row vs-type="flex" class="mt-4">
        <vs-col vs-lg="12">
          <p class="font-semibold">Endereço Sede</p>
        </vs-col>
      </vs-row>

      <vs-row vs-type="flex" vs-align="center" class="mt-4">
        <vs-col vs-lg="3" vs-sm="2" vs-xs="12">
          <label>Cidade</label>
          <vs-input
            v-model="city.descricao"
            :success="cityRequest"
            success-text="Cidade válida"
            :danger="!cityRequest"
            danger-text="Cidade não encontrada"
            class="w-full"/>
        </vs-col>

        <vs-col vs-lg="3" vs-sm="2" vs-xs="12">
          <label>Uf</label>
          <vs-input
            v-model="city.uf"
            :success="cityRequest"
            success-text="Cidade válida"
            :danger="!cityRequest"
            danger-text="Cidade não encontrada"
            class="w-full"/>
        </vs-col>

        <vs-col vs-lg="3" vs-sm="2" vs-xs="12">
          <label>Código IBGE</label>
          <vs-input
            v-model="city.codIbge"
            v-validate="'required'"
            disabled
            name="código ibge"
            description-text="Campo não editável"
            class="w-full"/>
        </vs-col>

        <vs-col vs-lg="3" vs-sm="2" vs-xs="12">
          <vs-button class="w-full" @click="loadCity">Buscar</vs-button>
        </vs-col>
      </vs-row>

      <vs-row vs-type="flex" class="mb-4">
        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <label>Descrição Logradouro:</label>
          <vs-select
            v-model="company.descrLogradouro"
            v-validate="'required'"
            autocomplete
            name="descrição logradouro"
            class="w-full d-inline">
            <vs-select-item :key="index" :value="item" :text="item" v-for="(item, index) in descrLogradouro"/>
          </vs-select>
        </vs-col>

        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <label>Logradouro</label>
          <vs-input
            v-model="company.logradouro"
            v-validate="'required'"
            name="logradouro"
            class="w-full"
          />
        </vs-col>
      </vs-row>

      <vs-row vs-type="flex" class="mb-4">
        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <label>Número</label>
          <NumericInput
            v-model="company.numero"
            v-validate="'required'"
            name="número"
            class="w-full"
          />
        </vs-col>

        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <label>CEP</label>
          <NumericInput
            v-model="company.cep"
            v-validate="'required'"
            name="cep"
            is-cep="true"
            class="w-full"
          />
        </vs-col>

        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <label>Bairro</label>
          <vs-input
            v-model="company.bairro"
            v-validate="'required'"
            name="bairro"
            class="w-full"
          />
        </vs-col>

        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <label>Telefone</label>
          <vs-input
            v-model="company.telefone1"
            name="telefone"
            class="w-full"
          />
        </vs-col>
      </vs-row>

      <vs-row vs-type="flex" class="mb-4">
        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <label>Número Fax</label>
          <vs-input
            v-model="company.dddFax"
            name="número fax"
            class="w-full"
          />
        </vs-col>

        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <label>E-mail</label>
          <vs-input
            v-model="company.correioEletronico"
            name="e-mail"
            class="w-full"
          />
        </vs-col>
      </vs-row>

      <vs-row vs-type="flex" class="mt-4">
        <vs-col vs-lg="12">
          <p class="font-semibold">Classificação Econômica</p>
        </vs-col>
      </vs-row>

      <vs-row vs-type="flex" class="mb-4">
        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <label>Estrutura Legal</label>
          <vs-select
            v-model="company.codLegalStructure"
            v-validate="'required'"
            autocomplete
            name="estrutura legal"
            class="w-full d-inline">
            <vs-select-item :key="index" :value="item.subClassJurd" :text="item.nomeSubClassJurd" v-for="(item, index) in legalEntities"/>
          </vs-select>
        </vs-col>

        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <label>Capital Social</label>
          <NumericInput
            v-model="company.capitalSocialEmpresa"
            v-validate="'required'"
            name="capital social"
            minimum-fraction-digits="2"
            class="w-full"
          />
        </vs-col>
      </vs-row>

      <vs-row vs-type="flex" class="mb-4">
        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <label>Data Início das Atividades</label>
          <date-picker
            v-model="company.dataInicioAtividade"
            v-validate="'required'"
            name="data início das atividades"
            format="DD-MM-YYYY"
            value-type="YYYY-MM-DD"
            class="w-full"/>
        </vs-col>

        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <label>CNAE</label>
          <vs-select
            v-model="company.cnaeCodigo"
            v-validate="'required'"
            name="cnae"
            autocomplete
            class="w-full d-inline">
            <vs-select-item :key="index" :value="item.codCnae" :text="item.nmCnae" v-for="(item, index) in cnaeList"/>
          </vs-select>
        </vs-col>
      </vs-row>

    </vx-card>

    <vs-row class="mb-4">
      <vs-button @click="back" vs-type="line" icon="arrow_back" class="mr-3">Voltar</vs-button>
      <vs-button @click="validate" vs-type="line" icon="save" class="mr-3">Salvar</vs-button>
    </vs-row>

  </div>
</template>

<script>
import axios from 'axios'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/pt-br'
import NumericInput from "@/components/NumericInput";
import CnpjInput from "@/components/CnpjInput";

export default {
  components: {
    DatePicker,
    NumericInput,
    CnpjInput
  },
  data() {
    return {
      company: {
        name: null,
        cnpj: null,
        cnpjAlfa: null,
        sectorName: null,
        companyType: null,
        descrLogradouro: null,
        logradouro: null,
        numero: null,
        complemento: null,
        bairro: null,
        cep: null,
        cidadeCodIbge: null,
        uf: null,
        municipio: null,
        telefone1: null,
        telefone2: null,
        dddFax: null,
        correioEletronico: null,
        capitalSocialEmpresa: null,
        dataInicioAtividade: null,
        cnaeCodigo: null,
        codLegalStructure: null,
      },
      city: {
        uf: '',
        descricao: '',
        codIbge: '',
      },
      cityRequest: false,
      sectors: [],
      cnaeList: [],
      companyTypes: [],
      descrLogradouro: [],
      legalEntities: [],
    }
  },
  beforeMount() {
    this.loadSectors()
    this.loadCnae()
    this.loadCompanyType()
    this.loadDescrLogradouro()
    this.loadLegalEntity()
  },
  methods: {
    loadSectors() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/sector`)
        .then((response) => {
          this.sectors = response.data
        })
    },
    loadCity() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/company-form/city`,
        {
          params: {
            uf: this.city.uf,
            descricao: this.city.descricao
          }
        })
        .then((response) => {
          this.city = response.data
          this.cityRequest = true
        })
        .catch(() => {
          this.cityRequest = false
        })
    },
    loadCnae() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/company-form/cnae`)
        .then((response) => {
          this.cnaeList = response.data
        })
    },
    loadCompanyType() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/company-form/types`)
        .then((response) => {
          this.companyTypes = response.data
        })
    },
    loadDescrLogradouro() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/company-form/descr-logradouro`)
        .then((response) => {
          this.descrLogradouro = response.data
        })
    },
    loadLegalEntity() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/company-form/legal-entity`)
        .then((response) => {
          this.legalEntities = response.data
        })
    },
    back() {
      this.$router.push({path: '/empresas'})
    },
    validate() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.save()
        } else {
          for (const idx in this.errors.items) {
            this.$vs.notify({
              color: 'danger',
              text: this.errors.items[idx].msg
            })
          }
        }
      })
    },
    save() {
      this.company.uf = this.city.uf
      this.company.cidadeCodIbge = this.city.codIbge

      axios.post(`${process.env.VUE_APP_API}/api/v1/company-form`, this.company)
        .then(() => {
          // this.$router.push({ path: '/empresas' })
        })
    }
  }
}
</script>
